import { Flex, GridItem, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { Creator } from "@nens/rana/api-v1";
import { DEFAULT_COLORS, RanaHeading } from "@nens/ranalib";
import { TenantUser } from "@nens/ranalib";

import { useRanaDroplets } from "@/hooks/use-rana-droplets";
import { Profile } from "@/lib/profile";

import { ContentPanel } from "../../../components/content-panel";
import { DASHBOARD_GRID_ITEM_HEIGHT } from "../tenant-details";

export const UserWelcomeBlock = ({ user }: { user: TenantUser | Creator }) => {
  const dropletsRef = useRanaDroplets({
    squareSize: 20,
    backgroundColor: DEFAULT_COLORS.brand.analytic,
    dropletColor: DEFAULT_COLORS.brand.glacier,
    radiusFunction: (x, y) => Math.max(1 - Math.sqrt((x / 12) ** 2 + (y / 4) ** 2), 0),
    alignX: "right",
    alignY: "bottom",
    offsetX: -8,
    offsetY: -15,
  });

  return (
    <GridItem height={DASHBOARD_GRID_ITEM_HEIGHT}>
      <ContentPanel bg="brand.analytic" ref={dropletsRef}>
        <Flex gap={6}>
          <Profile user="self" boxSize={16} />
          <RanaHeading color="white" type="h3">
            <FormattedMessage id="dashboard.welcome" defaultMessage="Welcome," />
            <Text>{user && user.givenName}</Text>
          </RanaHeading>
        </Flex>
      </ContentPanel>
    </GridItem>
  );
};
